import React, { useState } from "react";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import VendorSummary from "./VendorSummary";
import { getModuleNamingBySlug } from "../../../lib/Misc";
import { useOrganization } from "../../../lib/context/OrganisationContext";

const VendorStatementAction = ({ vendorId, trustId, vendor }) => {
  const { organizationData } = useOrganization();
  const [showStatement, setShowStatement] = useState(null);

  const toggleStatement = () => {
    setShowStatement(!showStatement);
  };
  return (
    <>
      <span style={{ whiteSpace: "nowrap" }}>
        <FontAwesomeIcon
          title="View Statement"
          onClick={toggleStatement}
          icon={faEye}
          size="1x"
        />
      </span>
      <ResponsiveDrawerForm
        description={""}
        title={`${getModuleNamingBySlug(
          organizationData?.organizationData,
          "vendors",
          "Vendor"
        )} Statment`}
        handleOpen={() => {}}
        handleClose={() => {}}
        className={"md:w-[90vw]"}
        open={showStatement}
        buttonClassName={""}
        setOpen={setShowStatement}
        read={true}
        popupType={"reports"}
      >
        <VendorSummary id={vendorId} trustId={trustId} vendor={vendor} />
      </ResponsiveDrawerForm>
    </>
  );
};

export default VendorStatementAction;
